import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['noticeContainer'];

  connect() {
    if (localStorage.getItem('dismissThirdPartyCookieWarning')) {
      this.closeNotice();
    }
  }

  dismissNotice(event) {
    if (event.currentTarget.checked) {
      localStorage.setItem('dismissThirdPartyCookieWarning', true);
      this.closeNotice();
    }
  }

  closeNotice() {
    this.noticeContainerTarget.classList.add('hidden');
  }

  handleLookerFrameMessages(event) {
    const lookerFrame = document.getElementById('looker-frame');
    if (lookerFrame && event.source === lookerFrame.contentWindow) {
      const eventData = JSON.parse(event.data);
      if (eventData.type === 'page:changed') this.closeNotice();
    }
  }
}
